export function updateBestScore(
  prevBestScore: number | null,
  newScore: number | null
) {
  if (prevBestScore === null) {
    return newScore;
  }

  if (newScore === null) {
    return prevBestScore;
  }

  return Math.max(prevBestScore, newScore);
}
